const LS_WORKSPACE = 'expense_admin_workspace_id'

let apiWorkspaceId: string | null = null
let workspaceVersion = 0
const workspaceListeners = new Set<() => void>()

/** Internal request lifetime, including A -> B -> A transitions. */
export function getApiWorkspaceVersion() { return workspaceVersion }
export function subscribeApiWorkspace(listener: () => void) {
  workspaceListeners.add(listener)
  return () => { workspaceListeners.delete(listener) }
}

function readStoredWorkspaceId(): string | null {
  if (typeof localStorage === 'undefined') return null
  try {
    return localStorage.getItem(LS_WORKSPACE)
  } catch {
    return null
  }
}

/** Sync id used for all /admin/* requests (X-Workspace-Id). */
export function setApiWorkspaceId(id: string | null) {
  const changed = apiWorkspaceId !== id
  apiWorkspaceId = id
  if (changed) {
    workspaceVersion++
    for (const listener of [...workspaceListeners]) listener()
  }
  if (typeof localStorage === 'undefined') return
  try {
    if (id) localStorage.setItem(LS_WORKSPACE, id)
    else localStorage.removeItem(LS_WORKSPACE)
  } catch {
    // ignore
  }
}

export function getApiWorkspaceId(): string | null {
  return apiWorkspaceId
}

if (typeof localStorage !== 'undefined') {
  const s = readStoredWorkspaceId()
  if (s) apiWorkspaceId = s
}
